// todo refactor this somehow once its approved as code looks not great...

import React from 'react'
import type { FC } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { highlightText } from '../highlightText'
import { stripHtml } from '../stripHtml'
import { Typography } from '@homeviews/shared-ui'
import { Box } from '@material-ui/core'

const useStyles = makeStyles(() =>
  createStyles({
    root: {},
    item: {
      marginBottom: 5,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    title: {
      marginBottom: 8,
    },
  }),
)

const ExcerptWithKeywords: FC<any> = ({
  data,
  keyword,
  preOffsetCharactersLimit = 100,
  postOffsetCharactersLimit = 100,
}) => {
  const classes = useStyles()

  if (!data?.length || !keyword) {
    return <span />
  }

  const excerpts = []

  data.map((item) => {
    const sanitizedText = stripHtml(item)
    let transformedText = ''

    const keywordIndex = item.toLowerCase().indexOf(keyword.toLowerCase())

    if (keywordIndex === -1) {
      return false
    }

    const preText = sanitizedText.slice(
      Math.max(0, keywordIndex - preOffsetCharactersLimit),
      keywordIndex + keyword.length,
    )

    const postText = sanitizedText.slice(
      keywordIndex + keyword.length,
      keywordIndex + keyword.length + postOffsetCharactersLimit,
    )

    transformedText = preText + postText

    transformedText = `...${highlightText(transformedText, keyword)}...`

    excerpts.push(transformedText)
  })

  if (!excerpts.length) {
    return <span />
  }

  return (
    <Box className={classes.root} marginTop={1.5}>
      <Typography variant="h4" color="primary" className={classes.title}>
        Search excerpt
      </Typography>
      {excerpts.map((excerpt, index) => (
        <Typography
          className={classes.item}
          key={index}
          dangerouslySetInnerHTML={{ __html: excerpt }}
        />
      ))}
    </Box>
  )
}

export default ExcerptWithKeywords
